import { extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import { useContext } from 'react';
import { SortContext } from '../../Table/utils/SortContext.js';
import { StyledTableBodyCell, TableCellContent } from './styled.js';
import { jsx } from 'react/jsx-runtime';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function TableBodyCell(props) {
  var children = props.children,
    stickyColumn = props.stickyColumn,
    maxWidth = props.maxWidth,
    rest = __rest(props, ["children", "stickyColumn", "maxWidth"]);
  var _ref = useContext(SortContext) || {},
    hideColRows = _ref.hideColRows;
  var headers = rest.headers.split(' ');
  var hide = Boolean(hideColRows === null || hideColRows === void 0 ? void 0 : hideColRows.find(function (colRow) {
    return headers.some(function (head) {
      return colRow === head;
    });
  }));
  return /*#__PURE__*/jsx(StyledTableBodyCell, _extends({
    "data-sticky-column": stickyColumn,
    $stickyColumn: stickyColumn,
    $hide: hide,
    $maxWidth: maxWidth
  }, rest, {
    children: /*#__PURE__*/jsx(TableCellContent, {
      children: children
    })
  }));
}

export { TableBodyCell };
